import React from 'react';
import classnames from 'classnames';

interface Props {
    steps: number;
    selectedIndex: number;
    onSelectIndex?: (index: number) => void;
}

const Paginator = ({ steps, selectedIndex, onSelectIndex }: Props) => (
    <div className={classnames('paginator', { 'paginator--hidden': steps <= 1 })}>
        {[...Array(steps).keys()].map((i) => (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            <a
                key={`page-${i}`}
                className={`paginator__page ${
                    i === selectedIndex ? 'paginator__page--active' : ''
                }`}
                onClick={() => onSelectIndex && onSelectIndex(i)}
            >
                {i + 1}
            </a>
        ))}
    </div>
);

export default Paginator;
